"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUserID;

var _useWebChatAPIContext = _interopRequireDefault(require("./internal/useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useUserID() {
  return [(0, _useWebChatAPIContext.default)().userID];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VVc2VySUQiLCJ1c2VXZWJDaGF0QVBJQ29udGV4dCIsInVzZXJJRCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hvb2tzL3VzZVVzZXJJRC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgdXNlV2ViQ2hhdEFQSUNvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VXZWJDaGF0QVBJQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZVVzZXJJRCgpOiBbc3RyaW5nXSB7XG4gIHJldHVybiBbdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS51c2VySURdO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxTQUFULEdBQStCO0VBQzVDLE9BQU8sQ0FBQyxJQUFBQyw2QkFBQSxJQUF1QkMsTUFBeEIsQ0FBUDtBQUNEIn0=